import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LocalStorageService } from 'src/app/_services/localStorage.service';

@Component({
  selector: 'app-cgu-client-modal',
  templateUrl: './cgu-client-modal.component.html',
  styleUrls: ['./cgu-client-modal.component.scss'],
  standalone: false,
})
export class CguClientModalComponent {
  role: any;
  isClient: boolean = false;
  isProfessional: boolean = false;

  constructor(
    private modalController: ModalController,
    private localStorageService: LocalStorageService
  ) {
    this.role = this.localStorageService.getUserRole();
    this.isClient = this.role === 'client';
    this.isProfessional = this.role === 'prestataire';
  }

  closeModal() {
    this.modalController.dismiss();
  }
}

